import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import * as actions from '../registrationActions';
import ConfirmSMSForm from './ConfirmSMSForm';
import StickyErrorMessageBox from '../../../components/ErrorMessage/StickyErrorMessageBox';

import { login } from '../../Auth/authActions';
import { setLoyaltyRegistrationModalOpen } from '../../Loyalty/loyaltyActions';
const ConfirmSMSFormContainer = ({
  registrationReducer,
  confirmSMS,
  handleBackButtonClick,
  updatePhoneNumber,
  requestingPatchPhoneNumber,
  patchPhoneNumberError,
  authErrors,
  enteredPhoneNumber,
  enteredEmail,
  setEnteredPhoneNumber,
  setEnteredEmail,
  selectedCategoryId,
  actionType,
  loginObject,
  login,
  resendRegistrationCode,
  setSelectedCategoryId,
  setLoginObject,
  isPasswordLess,
  patchPhoneNumberIsVisible,
  setPatchPhoneNumberIsVisible,
  clearAuthErrorMessage,
  clearVerificationCode,
  errors,
  setErrors,
  setLoyaltyRegistrationModalOpen,
  isCaptchaEnabled,
}) => {
  const [phoneNumber, setPhoneNumber] = useState('');

  useEffect(() => {
    if (!requestingPatchPhoneNumber && !patchPhoneNumberError) {
      setPhoneNumber('');
      setPatchPhoneNumberIsVisible(false);
    }
  }, [requestingPatchPhoneNumber]);
  return (
    <>
      <ConfirmSMSForm
        updatePhoneNumberButtonIsDisabled={
          !phoneNumber || phoneNumber.length < 10
        }
        updatePhoneNumber={updatePhoneNumber}
        phoneNumber={phoneNumber}
        setPhoneNumber={setPhoneNumber}
        confirmSMS={confirmSMS}
        patchPhoneNumberIsVisible={patchPhoneNumberIsVisible}
        setPatchPhoneNumberIsVisible={setPatchPhoneNumberIsVisible}
        handleBackButtonClick={handleBackButtonClick}
        isRequesting={registrationReducer.requestingConfirmSMS}
        authErrors={authErrors}
        enteredPhoneNumber={enteredPhoneNumber}
        enteredEmail={enteredEmail}
        selectedCategoryId={selectedCategoryId}
        actionType={actionType}
        loginObject={loginObject}
        setLoginObject={setLoginObject}
        login={login}
        resendRegistrationCode={resendRegistrationCode}
        setEnteredPhoneNumber={setEnteredPhoneNumber}
        setEnteredEmail={setEnteredEmail}
        setSelectedCategoryId={setSelectedCategoryId}
        isPasswordLess={isPasswordLess}
        clearAuthErrorMessage={clearAuthErrorMessage}
        isCodeCleared={registrationReducer.isCodeCleared}
        unconfirmedPhone={registrationReducer.unconfirmedPhone}
        clearVerificationCode={clearVerificationCode}
        errors={errors}
        setErrors={setErrors}
        setLoyaltyRegistrationModalOpen={setLoyaltyRegistrationModalOpen}
        isCaptchaEnabled={isCaptchaEnabled}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  registrationReducer: state.registrationReducer,
  requestingPatchPhoneNumber: state.authReducer.requestingPatchPhoneNumber,
  patchPhoneNumberError: state.authReducer.patchPhoneNumberError,
  authErrors: state.authReducer.authErrors,
  isPasswordLess: state.authReducer.appConfig.is_password_less,
  actionType: state.authReducer.actionType,
  isCaptchaEnabled: state.authReducer.appConfig?.is_captcha_enabled,
});

export default connect(mapStateToProps, {
  ...actions,
  login,
  setLoyaltyRegistrationModalOpen,
})(ConfirmSMSFormContainer);
